export const headerAgencyByAgencyGroupTable = [
  {
    headerStyles: 'w-[20%] font-semibold py-5 pl-4 ',
    rowWid: 'w-[20%] py-5 break-all pl-4 align-top',
    name: 'Agency Key',
    label: 'agencyKey',
    isFilter: true,
    isFilterDate: false,
    isOneLineRes: true,
  },
  {
    headerStyles: 'w-[60%] font-semibold py-5 pl-4 ',
    rowWid: 'w-[60%] py-5 break-all pl-4 align-top',
    name: 'Agency Name',
    label: 'agencyName',
    isFilter: true,
    isFilterDate: false,
    isOneLineRes: false,
  },
  {
    headerStyles: 'w-[20%] font-semibold py-5 pl-4 ',
    rowWid: 'w-[20%] py-5 break-all align-top pl-4',
    name: 'Action',
    label: 'action',
    isFilter: true,
    isFilterDate: false,
    isOneLineRes: false,
  },
]
